<div class="bp-modal mod-lg" [class.no-separator]="currentStep !== steps && currentStep !== 1">
  <bp-modal-header
		[title]="
			currentStep !== 7
				? ('security_settings_2fa_enable_modal_title' | translate)
				: ('security_settings_2fa_enable_modal_step_success_popup_title' | translate)
		">
    <a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">
      <strong>{{ "close" | translate }}</strong>
    </a>
    @if ((currentStep === 3 && !skipSmsPinStep) || currentStep === 4 || currentStep === 5) {
      <a
        left
        (click)="onClickBack()"
        (keydown.enter)="onClickBack()"
        [tabIndex]="0">
        <strong>{{ "back" | translate }}</strong>
      </a>
    }
  </bp-modal-header>
  @if (currentStep !== steps && currentStep !== 1) {
    <progress
      max="{{ steps - 2 }}"
    value="{{ currentStep - 1 }}"></progress>
  }
  <div class="bp-modal-body">
    <div class="bp-modal-body-section mod-wide pt-25 min-h-400">
      <!-- Step 1 - Enter Password -->
      @if (currentStep === 1) {
        <div>
          <div class="center-block max-w-468 text-center">
            <h2 class="mb-15 mt-90">
              {{ "security_settings_2fa_enable_modal_step_enter_password" | translate }}
            </h2>
            <p class="mb-20 description-text">
              {{ "security_settings_2fa_enable_modal_step_enter_password_description" | translate }}
            </p>
            <div
              class="form-group"
						[ngClass]="{
							'has-error': passwordError?.getValidationError('password')
						}">
              <input
                #loginpwd
                [type]="'password'"
                class="form-field"
                id="password"
                (keydown.enter)="onClickContinue()"
                [(ngModel)]="passInput"
                (ngModelChange)="passwordError = null"
                tabindex="2"
                name="password"
                autofocus
                placeholder="{{ 'security_settings_2fa_enable_modal_step_enter_password' | translate }}"
                required />
              @if (passwordError?.getValidationError('password')) {
                <div
                  class="form-error has-error align-left">
                  {{ passwordError?.getValidationError("password") }}
                </div>
              }
            </div>
          </div>
        </div>
      }
      <!-- Step 2 - SMS Verification -->
      @if (currentStep === 2) {
        <div>
          <verification-sms-code
            #smsPinInput
            (pinSent)="setSmsCode($event)"
            [password]="passInput"
          [codeLength]="4"></verification-sms-code>
        </div>
      }
      <!-- Step 3 - Save recovery code -->
      @if (currentStep === 3) {
        <div>
          <div class="center-block max-w-550 text-center">
            <h2 class="mb-15 mt-30">
              {{ "security_settings_2fa_enable_modal_step_save_recovery_title" | translate }}
            </h2>
            <p class="mb-15 description-text">
              {{ "security_settings_2fa_enable_modal_step_save_recovery_description" | translate }}
            </p>
            <a (click)="onClickDownloadPDF()">
              {{ "security_settings_2fa_enable_modal_step_save_recovery_pdf" | translate }}
            </a>
          </div>
          <div class="center-block max-w-550 mt-20">
            <div>
              <strong>
                {{ "security_settings_2fa_enable_modal_step_save_recovery_your_code" | translate }}
              </strong>
            </div>
            <div class="save-copy-text-container">
              {{ secretKey }}
              <a
                class="bpi__icon-clipboard right-copy-icon"
                [copyToClipboard]="secretKey"
              [copyInfo]="'security_settings_2fa_enable_modal_step_save_recovery_copied' | translate"></a>
            </div>
            <div class="save-copy-note">
              {{ "security_settings_2fa_enable_modal_step_save_recovery_note" | translate }}
            </div>
          </div>
        </div>
      }
      <!-- Step 4 - Type recovery code -->
      @if (currentStep === 4) {
        <div>
          <div class="center-block max-w-468 text-center">
            <h2 class="mb-15 mt-90">
              {{ "security_settings_2fa_enable_modal_step_input_recovery_title" | translate }}
            </h2>
            <p class="mb-20 description-text">
              {{ "security_settings_2fa_enable_modal_step_input_recovery_description" | translate }}
            </p>
            <bp-input
              [type]="'text'"
              [(value)]="recoveryInputValue"
              [error]="recoveryInputError | translate"
              (valueChange)="recoveryInputError = null"
              [placeholder]="'security_settings_2fa_enable_modal_step_input_recovery_title' | translate"
            autofocus></bp-input>
          </div>
        </div>
      }
      <!-- Step 5 - Scan QR Code -->
      @if (currentStep === 5) {
        <div>
          <div class="center-block max-w-920 text-center">
            <div class="center-block max-w-385 text-center">
              <h2 class="mb-15 mt-30">
                {{ "security_settings_2fa_enable_modal_step_scan_qrcode_title" | translate }}
              </h2>
            </div>
            <p class="mb-15 description-text max-w-600 center-block text-center">
              {{ "security_settings_2fa_enable_modal_step_scan_qrcode_description" | translate }}
            </p>
            <div class="min-h-100">
              <a (click)="openQr()" tabindex="1">
                <qrcode class="qr-code-img" [qrdata]="QRdata" [width]="200" [errorCorrectionLevel]="'M'">
                </qrcode>
              </a>
            </div>
            <hr class="mb-15 mt-15" />
            <div>
              <span>
                {{
                "security_settings_2fa_enable_modal_step_scan_qrcode_secret_key_description" | translate
                }}
              </span>
              <p class="description-text">
                <strong>{{ secretKey }}</strong>
              </p>
            </div>
          </div>
        </div>
      }
      <!-- Step 6 - Enter verification code -->
      @if (currentStep === 6) {
        <div>
          <div class="center-block max-w-550 text-center">
            <two-fa (save)="onFinishedCodeInput($event)">
              <div description class="mb-20">
                <h2 class="mt-60 mb-0">
                  {{ "security_settings_2fa_enable_modal_step_input_pin_code_almost_done" | translate }}
                </h2>
                <h2 class="mb-15">
                  {{ "security_settings_2fa_enable_modal_step_input_pin_code_title" | translate }}
                </h2>
                <p class="mb-20 description-text">
                  {{ "security_settings_2fa_enable_modal_step_input_pin_code_description" | translate }}
                </p>
              </div>
            </two-fa>
          </div>
        </div>
      }
      <!-- Step 7 - Successfully activated -->
      @if (currentStep === 7) {
        <div>
          <div class="center-block max-w-550 text-center mb-50">
            <div class="success-symbol mod-green mb-20 mt-70 center-block">
              <span class="bpi__icon-check"></span>
            </div>
            @if (profile$ | async; as profile) {
              <h2 class="mt-20 mb-0 max-w-468 center-block text-center">
                {{
                "security_settings_2fa_enable_modal_step_success_title_name" | translate: [profile.forename]
                }}
              </h2>
            }
            <h2 class="max-w-468 center-block text-center">
              {{ "security_settings_2fa_enable_modal_step_success_title_simple" | translate }}
            </h2>
            <p class="mb-15 mt-20 description-text">
              {{ "security_settings_2fa_enable_modal_step_success_description" | translate }}
            </p>
          </div>
          <button
            class="btn btn-primary center-block text-center mt-30 min-w-135 mb-60"
            (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_step_success_button" | translate }}
          </button>
        </div>
      }
    </div>
    @if (currentStep !== 7) {
      <div class="modal-footer-2fa">
        @if (currentStep === 1) {
          <button
            class="btn btn-primary continue-button"
            (click)="onClickContinue()"
            [disabled]="!passInput">
            {{ "security_settings_2fa_enable_modal_button_continue" | translate }}
          </button>
        }
        @if (currentStep === 2) {
          <button
            class="btn btn-primary continue-button"
            [disabled]="!smsCode"
            (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_button_continue" | translate }}
          </button>
        }
        @if (currentStep === 3) {
          <button class="btn btn-primary continue-button" (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_button_continue" | translate }}
          </button>
        }
        @if (currentStep === 4) {
          <button
            class="btn btn-primary continue-button"
            [disabled]="!recoveryInputValue"
            (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_button_continue" | translate }}
          </button>
        }
        @if (currentStep === 5) {
          <button class="btn btn-primary full-width-button" (click)="onClickContinue()">
            {{ "security_settings_2fa_enable_modal_step_input_pin_code_button" | translate }}
          </button>
        }
        @if (currentStep === 6) {
          <button
            class="btn btn-primary full-width-button"
            (click)="onClickContinue()"
            [disabled]="!verifyCodeInputValue">
            {{ "security_settings_2fa_enable_modal_step_input_pin_code_button" | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>
